import API from '@/api'
import mixin from './index'
import {
  CLASSCARD_MODULE_IDS,
  COMMON_RESET_COMMIT,
  LEAVE_ROLE
} from '@/utils/constUtils'
import { mcToast, mcOpenLink, mcAlert } from '@/utils/mcSdkUtils'
import {
  timeFormat,
  deepCopy,
  isCubePlatform,
  isHeEducationPlatform
} from '@/utils/comUtils'
import { h5Host } from '@/env'
import {
  educationalMenus,
  mainMenus,
  otherMenus,
  devicesMenus,
  leaveSchoolMenus,
  securityMenus,
  basicMenus,
  serveMenus,
  evaluationMenus
} from '@/pages/menu'
import {
  educationalMenusZj,
  mainMenusZj,
  otherMenusZj,
  devicesMenusZj,
  leaveSchoolMenusZj,
  securityMenusZj,
  basicMenusZj,
  serveMenusZj,
  evaluationMenusZj
} from '@/pages/zjCubeMenu'
import {
  educationalMenusHe,
  mainMenusHe,
  otherMenusHe,
  devicesMenusHe,
  leaveSchoolMenusHe,
  securityMenusHe,
  basicMenusHe,
  serveMenusHe,
  evaluationMenusHe
} from '@/pages/heEducationMenu'
export default {
  mixins: [mixin],
  data() {
    return {
      isZjCube: isCubePlatform(),
      LEAVE_ROLE,
      tipMsg: '', // 使用提示
      needTip: false, // 是否需要模版提示
      hasExpired: false, // 已过期
      skuType: 0, // 1: 试用版 2: 标准版 3: 高级版 4: 高级版 + 永久免费版
      messageIdList: [],
      copyConfirm: false,
      copyEmail: 'chanpin@moredian.com',
      CLASSCARD_MODULE_IDS,
      bannerList: [],
      moduleIdList: [],
      visible: false,
      campusEducationalMenus: educationalMenus,
      campusMainMenus: mainMenus,
      campusOtherMenus: otherMenus,
      campusDevicesMenus: devicesMenus,
      campusLeaveSchoolMenus: leaveSchoolMenus,
      campusSecurityMenus: securityMenus,
      campusBasicMenus: basicMenus,
      campusServeMenus: serveMenus,
      campusEvaluationMenus: evaluationMenus,
      orgSku: this.$store.getters.skuInfo || {},
      isHeEducation: isHeEducationPlatform()
    }
  },
  computed: {
    computedHeaderInfo() {
      if (this.curIsGuardian) return '家长'
      window.localStorage.removeItem('currentCapmusId')
      let _name = this.$store.getters.currentCapmus || {}
      let _result = ''
      let campusName =
        _name.name.length > 12
          ? _name.name.substring(0, 12) + '...'
          : _name.name
      if (this.curIsTeacher || this.curIsAdmin) {
        _result += `老师 / ${campusName}`
      }
      return _result
    },
    swiperOptions() {
      return {
        // 开始滚动位置
        startSlide: 0,
        // 滚动速度
        speed: 400,
        // 自动轮播时间
        autoplay: this.bannerList.length > 1,
        // 是否无限循环
        loop: this.bannerList.length > 1,
        // 是否禁止页面滚动
        disableScroll: false,
        // 阻止冒泡
        stopPropagation: false,
        // 横向
        horizontal: true
      }
    },
    appEducationalMenus() {
      return this.campusEducationalMenus
        .filter(
          v =>
            this.moduleIdList.includes(v.module) &&
            // 家长留言模块和其他模块不一样 其他模块权限不匹配的时候也要展示 点击进去懂啊具体的界面会判断有无权限 留言模块是不展示 做下特殊判断
            (v.access.length === 1 && v.access[0] === LEAVE_ROLE.guardian
              ? this.currentRole === LEAVE_ROLE.guardian
              : // 设备管理的模块只有管理员可见
              v.belong === 'deviceMange'
              ? this.isAdmin
              : true)
        )
        .filter(item => {
          return ['schoolCalendar'].includes(item.title) ? this.isAdmin : true
        })
    },
    appLeaveSchoolMenus() {
      return this.campusLeaveSchoolMenus.filter(v =>
        this.moduleIdList.includes(v.module)
      )
    },
    appOtherList() {
      // 管理员可看所有模块
      return this.campusOtherMenus.filter(
        item => this.moduleIdList.includes(item.module) && this.isAdmin
      )
    },
    appDeviceList() {
      // 管理员可看所有模块
      // 非管理员只能看到班牌门禁之外的模块
      return this.campusDevicesMenus.filter(
        item => this.moduleIdList.includes(item.module) && this.isAdmin
      )
    },
    appBasicList() {
      // 管理员可看所有模块
      return this.campusBasicMenus
        .filter(item => this.moduleIdList.includes(item.module))
        .filter(item => {
          return ['schoolCalendar', 'rights'].includes(item.title)
            ? this.isAdmin
            : true
        })
    },
    appServeList() {
      // 管理员可看所有模块
      return this.campusServeMenus
        .filter(item => this.moduleIdList.includes(item.module))
        .filter(item => {
          return ['meeting', 'visitor'].includes(item.title)
            ? this.isAdmin
            : true
        })
    },
    appEvaluationList() {
      // 管理员可看所有模块
      return this.campusEvaluationMenus.filter(item =>
        this.moduleIdList.includes(item.module)
      )
    },
    appSecurityList() {
      // 管理员可看所有模块
      return this.campusSecurityMenus.filter(item =>
        this.moduleIdList.includes(item.module)
      )
    },
    appList() {
      let _list = []
      if (this.curIstudent) {
        _list = [
          {
            id: 1,
            name: '学生请假',
            path: '/leave/index',
            icon: '&#xe677;',
            module: '2'
          }
        ]
      } else {
        // 老师 家长 全部展示，点击具体模块时 再判断权限
        // 非管理员只能看到班牌、门禁、大屏之外的模块
        _list = this.campusMainMenus.filter(
          v =>
            this.moduleIdList.includes(v.module) &&
            (+v.module !== 22 || this.curIsGuardian)
        )
      }
      return _list
    }
  },
  watch: {},
  created() {
    if (this.isZjCube) {
      /* eslint-disable */
      this.campusEducationalMenus = educationalMenusZj.filter(
        item =>
          this.orgSku.moduleIdList.some(moduleId => moduleId === item.module) &&
          (item.platformSources
            ? item.platformSources.findIndex(
                plat => plat === +this.platformSource
              ) > -1
            : true)
      )
      /* eslint-enable */
      this.campusMainMenus = mainMenusZj
      this.campusOtherMenus = otherMenusZj
      this.campusDevicesMenus = devicesMenusZj
      this.campusBasicMenus = basicMenusZj
      this.campusServeMenus = serveMenusZj
      this.campusEvaluationMenus = evaluationMenusZj
      this.campusLeaveSchoolMenus = leaveSchoolMenusZj
      this.campusSecurityMenus = securityMenusZj
    }
    if (this.isHeEducation) {
      /* eslint-disable */
      this.campusEducationalMenus = educationalMenusHe.filter(
        item =>
          this.orgSku.moduleIdList.some(moduleId => moduleId === item.module) &&
          (item.platformSources
            ? item.platformSources.findIndex(
                plat => plat === +this.platformSource
              ) > -1
            : true)
      )
      /* eslint-enable */
      this.campusMainMenus = mainMenusHe
      this.campusOtherMenus = otherMenusHe
      this.campusDevicesMenus = devicesMenusHe
      this.campusBasicMenus = basicMenusHe
      this.campusServeMenus = serveMenusHe
      this.campusEvaluationMenus = evaluationMenusHe
      this.campusLeaveSchoolMenus = leaveSchoolMenusHe
      this.campusSecurityMenus = securityMenusHe
    }

    this.getBannerList()
    this.$nextTick(() => {
      this.fetchTips()
    })
    COMMON_RESET_COMMIT.forEach(item => {
      this.$store.commit(item.key, item.value)
    })
    // 开通模块 1:考勤，2:请假，3: 体温，4: 宿管，5: 录脸，6: 门禁 7: 大屏 8: 弹性离校 9: 德育考评
    let _ids = deepCopy(this.orgSku.moduleIdList || [])
    const _incomingIds = deepCopy(this.orgSku.incomingModuleIdList || [])
    this.moduleIdList = _ids.concat(_incomingIds)
  },
  methods: {
    verifyModuleAccess(module = '') {
      return this.moduleList.includes(+module)
    },
    handlerAccess(app) {
      this.$router.push({
        path: '/access',
        query: {
          name: app.name
        }
      })
    },
    handlerGoBanner(item) {
      if (item.accessType === 'outside') {
        this.$router.push({
          path: '/banner-iframe',
          query: {
            url: item.accessUrl
          }
        })
      } else {
        this.mixinRouter(item.pageUrl, item)
      }
    },
    // 查Banner列表
    getBannerList() {
      return new Promise((resolve, reject) => {
        API.getCommonBanner({
          type: this.curIsGuardian ? 'school_guardian_banner' : 'school'
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              reject(res)
              return
            }
            res.map(v => {
              v.code = v.name
              v.pageUrl = v.accessUrl
            })
            this.bannerList = res
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 复制邮箱成功
    handleCopySuccess() {
      this.copyConfirm = false
      mcToast({ msg: '复制成功' })
    },
    // 展示意见收纳
    showConfirm() {
      this.copyConfirm = true
    },
    handlerToChangeRole() {
      if (this.isCanChangeRole) {
        this.$router.push('/role')
      }
    },
    // 跳转外链
    handlerLinkOthers(app, page) {
      // 家长首页不校验，按原来的逻辑处理
      if (page === 'pageHome' && !this.verifyModuleAccess(app.module)) {
        return this.handlerAccess(app)
      }
      if (app.routerType === 2) {
        if ((app.query || {}).deviceType) {
          this.$store.commit('setDeviceManageType', app.query.deviceType)
        }
        this.$router.push({
          path: app.path,
          query: {
            $moduleId: app.module
          }
        })
      } else {
        if (app.title === 'visitor') {
          window.open(
            `${h5Host}/visitor/?corpId=${this.corpId}&campusRole=${this.currentRole}`
          )
        } else {
          const _path = app.multiple ? app.path[this.currentRole] : app.path
          console.log(_path)
          mcOpenLink({
            url: _path
          })
        }
      }
    },

    fetchTips() {
      let _res = this.orgSku
      let _expireTime = +this.orgSku.validOrderExpireDate - 1000 || 0
      let _expireDate = timeFormat(new Date(_expireTime))
      let _msg = ''
      window.localStorage.setItem('hasLogin', true)
      let _hasExpired = (this.hasExpired = +new Date().getTime() >= _expireTime)
      this.needTip = _expireTime - +new Date().getTime() <= 604800000 // 7 * 24 * 60 * 60 * 1000
      if (this.needTip) {
        if (_hasExpired) {
          if (_res.free) {
            _msg = `尊敬的用户，您的套餐已到期，到期后仅可使用免费功能，如需继续使用，请及时续费/升级`
          } else if (+_res.skuType === 4) {
            // 永久版 + 高级版 =》 切换免费版
            this.needTip = false
          } else {
            _msg = `尊敬的用户，您的套餐已到期，到期后仅可使用免费功能，如需继续使用，请及时续费/升级`
          }
        } else {
          if (_res.free) {
            _msg = `当前使用的版本为试用版, 有效期至${_expireDate}, 为保证正常使用, 请及时续费/升级`
          } else if (+_res.skuType === 4) {
            // 永久版 + 高级版
            _msg = `${_res.skuName}使用权限即将到期, 到期时间: ${_expireDate}, 为保证正常使用, 请及时续费`
          } else {
            _msg = `使用权限即将到期, 到期时间: ${_expireDate}, 为保证正常使用, 请及时续费/升级`
          }
        }
        this.tipMsg = _msg
        this.needTip = this.curIsAdmin
      }
    },
    showTips() {
      mcAlert({
        buttonName: '我知道了',
        msg: this.tipMsg,
        title: ''
      })
    }
  }
}
